import React from 'react';
import _Home from '../components/_Home';
import MainLayoutHome from '../layout/MainLayoutHome';

const HomePage = () => {
  return (
    <MainLayoutHome>
        <_Home/>
    </MainLayoutHome>
  )
}

export default HomePage